.header {
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: 1px solid #979797;
  display: flex;
  height: var(--header-height);
}

.logo {
  width: 171px;
  padding: 10px;
}

.menu {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-right: 10px;
}

.headerLink {
  position: relative;
  color: #4f4f4f;
  font-size: 14px;
  font-family: var(--font-family__heading);
  text-decoration: none;
  display: block;
  height: 30px;
  padding: 0 8px;
  // min-width: 68px;
  text-align: center;
  box-sizing: border-box;
}

.headerLinkActive {
  @extend .headerLink;
  color: #007ec0;
  &::after {
    content: '';
    position: absolute;
    height: 4px;
    width: 100%;
    left: 0;
    bottom: -2px;
    background-color: #007ec0;
  }
}

.linkWrapper {
  margin-right: 50px;
  position: relative;
}
